import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum SecondVsDirectAssets {
    CIG_FLIPPED = "SecondVsDirectCIG_FLIPPED",
    SMOKER_LUNGS = "SecondVsDirectSMOKER_LUNGS",
    SMOKER_LUNGS_FLIPPED = "SecondVsDirectSMOKER_LUNGS_FLIPPED",
    SMOKE_ANIM = "SecondVsDirectSMOKE_ANIM",
    SMOKE_ANIM_FLIPPED = "SecondVsDirectSMOKE_ANIM_FLIPPED",
    VAPOR_ANIM = "SecondVsDirectVAPOR_ANIM",
    VAPOR_ANIM_FLIPPED = "SecondVsDirectVAPOR_ANIM_FLIPPED",

    VAPE_PEN = "SecondVsDirectVAPE_PEN",
    BACKGROUND = "SecondVsDirectBACKGROUND",
    BODY = "SecondVsDirectBODY",
    SMOKE_TITLE = "SecondVsDirectSMOKE_TITLE",
    VAPOR_TITLE = "SecondVsDirectVAPOR_TITLE",
    SMOKE_CIRCLE = "SecondVsDirectSMOKE_CIRCLE",
    VAPE_SMOKE = "SecondVsDirectVAPE_SMOKE",

    INTRO = "SecondVsDirectINTRO",
    SMOKING_AUDIO = "SecondVsDirectSMOKING_AUDIO",
    VAPING_AUDIO = "SecondVsDirectVAPING_AUDIO",
}

export function loadAssets(game: Phaser.Game) {
    game.load.spritesheet(SecondVsDirectAssets.CIG_FLIPPED, CCUtils.asset("second-hand/second-vs-direct/cig-flipped.png"), 85, 159)
    game.load.spritesheet(SecondVsDirectAssets.SMOKER_LUNGS, CCUtils.asset("second-hand/second-vs-direct/smoker-lungs.png"), 115, 94)
    game.load.spritesheet(SecondVsDirectAssets.SMOKER_LUNGS_FLIPPED, CCUtils.asset("second-hand/second-vs-direct/smoker-lungs-flipped.png"), 115, 94)
    game.load.spritesheet(SecondVsDirectAssets.SMOKE_ANIM, CCUtils.asset("second-hand/second-vs-direct/smoke-anim.png"), 114, 146)
    game.load.spritesheet(SecondVsDirectAssets.SMOKE_ANIM_FLIPPED, CCUtils.asset("second-hand/second-vs-direct/smoke-anim-flipped.png"), 114, 146)
    game.load.spritesheet(SecondVsDirectAssets.VAPOR_ANIM, CCUtils.asset("second-hand/second-vs-direct/vapor-anim.png"), 114, 146)
    game.load.spritesheet(SecondVsDirectAssets.VAPOR_ANIM_FLIPPED, CCUtils.asset("second-hand/second-vs-direct/vapor-anim-flipped.png"), 114, 146)

    game.load.image(SecondVsDirectAssets.VAPE_PEN, CCUtils.asset("second-hand/second-vs-direct/vape-pen.png"))
    game.load.image(SecondVsDirectAssets.BACKGROUND, CCUtils.asset("second-hand/long-term/rat-table.png"))
    game.load.image(SecondVsDirectAssets.BODY, CCUtils.asset("second-hand/second-vs-direct/body.png"))
    game.load.image(SecondVsDirectAssets.SMOKE_TITLE, CCUtils.asset("second-hand/second-vs-direct/title-smoking-vs-secondhand-smoke.png"))
    game.load.image(SecondVsDirectAssets.VAPOR_TITLE, CCUtils.asset("second-hand/second-vs-direct/title-vaping-vs-secondhand-vapor.png"))
    game.load.image(SecondVsDirectAssets.SMOKE_CIRCLE, CCUtils.asset("second-hand/second-vs-direct/smoke-circle.png"))
    game.load.image(SecondVsDirectAssets.VAPE_SMOKE, CCUtils.asset("second-hand/second-vs-direct/vape-smoke.png"))

    game.load.audio(SecondVsDirectAssets.INTRO, CCUtils.asset("second-hand/second-vs-direct/audio/shs-or-vapor-intro.mp3"))
    game.load.audio(SecondVsDirectAssets.SMOKING_AUDIO, CCUtils.asset("second-hand/second-vs-direct/audio/smoking-vs-secondhand-smoking.mp3"))
    game.load.audio(SecondVsDirectAssets.VAPING_AUDIO, CCUtils.asset("second-hand/second-vs-direct/audio/vapor-vs-second-hand-vapor.mp3"))
}
